import { Block, Clear, Done, Edit, Print } from "@mui/icons-material";
import { Typography } from "@mui/material";
import moment from "moment";
import { useSelector } from "react-redux";
import { stringToTitleCase } from "../../../../../../utils/util";
import { StyledAppointmentDetailsCard } from "../../../../../styled/appointments";

const AppointmentDetailCards = ({
  data,
  onAttended,
  onUnAttended,
  onEdit,
  onCancelled,
  onPrintSession,
}) => {
  const esPrestador = useSelector((state) => state.auth.roles?.PRESTADOR);
  const roles = useSelector((state) => state.auth.roles);
  const esSoporte = roles?.SOPORTE || roles?.ADMIN;
  const calendar = useSelector(
    (state) => state.accidentDashboard.appointmentsCalendar,
  );

  const disabledIfInformedONulled = (appointment) => {
    return appointment.estado === "Ausentes"
      || appointment.estado === "Presentes"
      || appointment.estado === "Anulados";
  }

  const disabledButtons = !calendar.data.isCalendarEnabled || esSoporte;

  return (
    <StyledAppointmentDetailsCard.Container>
      {data.map((appointment) => (
        <StyledAppointmentDetailsCard.Card
          elevation={2}
          key={appointment.idTurnoSiniestro}>
          <StyledAppointmentDetailsCard.AppointmentContainer>
            <StyledAppointmentDetailsCard.AppointmentDate variant="body2">
              {moment(appointment.fechaHora).format("YYYY/MM/DD HH:mm")}
            </StyledAppointmentDetailsCard.AppointmentDate>
            <Typography variant="body2">
              <b>Profesional:</b> {appointment.profesionalApellidoNombre}
            </Typography>
            <Typography variant="body2">
              <b>Matrícula:</b> {appointment.matricula}
            </Typography>
            <Typography variant="body2">
              <b>Especialidad:</b> {appointment.especialidadNombre}
            </Typography>
            <Typography variant="body2">
              <b>Observación:</b> {appointment.observacion}
            </Typography>
            <Typography variant="body2">
              <b>Estado:</b> {stringToTitleCase(appointment.estado.slice(0, -1))}
            </Typography>
          </StyledAppointmentDetailsCard.AppointmentContainer>
          {(esPrestador || esSoporte) && (
            <StyledAppointmentDetailsCard.ActionsContainer>
              <StyledAppointmentDetailsCard.Tooltip title="Concurrió">
                <StyledAppointmentDetailsCard.Button
                  disabled={disabledButtons || disabledIfInformedONulled(appointment)}
                  onClick={() => onAttended(appointment)}>
                  <Done />
                </StyledAppointmentDetailsCard.Button>
              </StyledAppointmentDetailsCard.Tooltip>
              <StyledAppointmentDetailsCard.Tooltip title="No Concurrió">
                <StyledAppointmentDetailsCard.Button
                  disabled={disabledButtons || disabledIfInformedONulled(appointment)}
                  onClick={() => onUnAttended(appointment)}>
                  <Block />
                </StyledAppointmentDetailsCard.Button>
              </StyledAppointmentDetailsCard.Tooltip>
              <StyledAppointmentDetailsCard.Tooltip title="Editar">
                <StyledAppointmentDetailsCard.Button
                  disabled={disabledButtons || disabledIfInformedONulled(appointment)}
                  onClick={() => onEdit(appointment)}>
                  <Edit />
                </StyledAppointmentDetailsCard.Button>
              </StyledAppointmentDetailsCard.Tooltip>
              <StyledAppointmentDetailsCard.Tooltip title="Anular">
                <StyledAppointmentDetailsCard.Button
                  disabled={disabledButtons || disabledIfInformedONulled(appointment)}
                  onClick={() => onCancelled(appointment)}>
                  <Clear />
                </StyledAppointmentDetailsCard.Button>
              </StyledAppointmentDetailsCard.Tooltip>
              <StyledAppointmentDetailsCard.Tooltip title="Imprimir Sesión">
                <StyledAppointmentDetailsCard.Button
                  onClick={() => onPrintSession(appointment)}>
                  <Print />
                </StyledAppointmentDetailsCard.Button>
              </StyledAppointmentDetailsCard.Tooltip>
            </StyledAppointmentDetailsCard.ActionsContainer>
          )}
        </StyledAppointmentDetailsCard.Card>
      ))}
    </StyledAppointmentDetailsCard.Container>
  );
};

export default AppointmentDetailCards;
